module.exports = __webpack_public_path__ + "img/340-goethe_johann_wolfgang_von_quotes.08194215.jpeg";